import { render, staticRenderFns } from "./BookManage.vue?vue&type=template&id=465bc5f3&"
import script from "./BookManage.vue?vue&type=script&lang=js&"
export * from "./BookManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports